import { render, staticRenderFns } from "./addContactsList.vue?vue&type=template&id=305aab30&"
import script from "./addContactsList.vue?vue&type=script&lang=js&"
export * from "./addContactsList.vue?vue&type=script&lang=js&"
import style0 from "./addContactsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports